import React from "react";
import LoadingPlaceholder from "./LoadingPlaceholder";

/**
 * Schaltfläche mit Icon. Das Label wird als tooltip angezeigt.
 * @param id
 * @param label
 * @param iconName
 * @param onClick
 * @param loading
 * @returns {JSX.Element}
 * @constructor
 */
function EAFlyByButton({ id, label, iconName, onClick, loading }) {
    return loading ? (
        <LoadingPlaceholder className={"flyByButton"} style={{ cursor: "default" }} />
    ) : (
        <div title={label} onClick={onClick} id={id} className={"flyByButton icon " + iconName} />
    );
}

export default EAFlyByButton;
